require('slick-carousel');

export function sl2() {
  $('[data-sl2]').slick({
    dots: true,
    slidesToShow: 1,
    autoplay: true,
    centerMode: true,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 4000,
    responsive: [
      {
        breakpoint: 561,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
          centerMode: false,
        },
      },
    ],
  });
}
